<template>
  <el-card shadow="never">
    <div style="height: 500px; width: auto">
      <div class="test-div">
        <img style="width: 100%" src="http://szsxtravel.top/1.png" alt="" />
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "traver-data",
};
</script>

<style>
.test-div {
  background-color: blanchedalmond;
  border-radius: 25px;
  border: 1px solid black;
  height: 200px;
  width: 400px;
}
</style>